import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack } from '../../Stack';


export const Container: FC<PropsWithChildren<ReactNode>> = ({ children }) => (
    <Stack
        sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'grayscale.shade40',
            borderRadius: 4,
            backgroundColor: 'grayscale.shade0',
            boxShadow:
                '0px 8px 24px rgba(0, 0, 0, 0.05), 0px 2px 8px rgba(0, 0, 0, 0.05)',
        }}
    >
        {children}
    </Stack>
);
